import { useLanguage } from '../i18n/LanguageContext';
function getPageItems(currentPage, totalPages) {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  const pages = new Set([1, totalPages, currentPage]);

  if (currentPage > 1) pages.add(currentPage - 1);
  if (currentPage < totalPages) pages.add(currentPage + 1);
  if (currentPage <= 3) {
    pages.add(2);
    pages.add(3);
  }
  if (currentPage >= totalPages - 2) {
    pages.add(totalPages - 1);
    pages.add(totalPages - 2);
  }

  const sortedPages = [...pages]
    .filter((page) => page >= 1 && page <= totalPages)
    .sort((a, b) => a - b);

  return sortedPages.flatMap((page, index) => {
    if (index === 0) return [page];
    const previous = sortedPages[index - 1];
    return page - previous > 1 ? [`ellipsis-${previous}-${page}`, page] : [page];
  });
}

function Pagination({
  currentPage,
  total,
  pageSize,
  onPageChange,
  info,
  disabled = false,
}) {
  const { t } = useLanguage();
  const totalPages = Math.max(1, Math.ceil(Number(total || 0) / pageSize));
  const pageItems = getPageItems(currentPage, totalPages);

  const movePage = (nextPage) => {
    if (disabled) return;
    if (nextPage < 1 || nextPage > totalPages || nextPage === currentPage) return;
    onPageChange(nextPage);
  };

  return (
    <div className="pagination">
      <span className="pagination-info">{info}</span>
      <div className="pagination-controls">
        <button
          type="button"
          className={`page-btn ${currentPage <= 1 ? 'disabled' : ''}`}
          disabled={disabled || currentPage <= 1}
          onClick={() => movePage(currentPage - 1)}
        >
          {t("이전")}
        </button>
        {pageItems.map((item) => (
          typeof item === 'number' ? (
            <button
              key={item}
              type="button"
              className={`page-btn ${currentPage === item ? 'active' : ''}`}
              disabled={disabled || currentPage === item}
              onClick={() => movePage(item)}
            >
              {item}
            </button>
          ) : (
            <span key={item} className="page-ellipsis">...</span>
          )
        ))}
        <button
          type="button"
          className={`page-btn ${currentPage >= totalPages ? 'disabled' : ''}`}
          disabled={disabled || currentPage >= totalPages}
          onClick={() => movePage(currentPage + 1)}
        >
          {t("다음")}
        </button>
      </div>
    </div>
  );
}
export default Pagination;
